import AuthenticatedLayout from '../../components/AuthenticatedLayout'
import { useForm, Link } from '@inertiajs/react'
import FormField from '../../components/FormField'
import Button from '../../components/Button'

export default function TeamsNew() {
  const { data, setData, post, processing, errors } = useForm({ name: '' })

  function handleSubmit(e) {
    e.preventDefault()
    post('/teams')
  }

  return (
    <AuthenticatedLayout>
      <div className="max-w-lg">
        <div className="mb-6">
          <Link href="/teams" className="text-sm text-indigo-600 hover:underline">← Lag</Link>
          <h1 className="text-2xl font-bold text-gray-900 mt-2">Nytt lag</h1>
        </div>
        <div className="bg-white rounded-xl border border-gray-200 p-6">
          <form onSubmit={handleSubmit} className="space-y-5">
            <FormField label="Lagnamn" error={errors.name}>
              <input
                type="text"
                value={data.name}
                onChange={e => setData('name', e.target.value)}
                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
              />
            </FormField>
            <div className="flex gap-3">
              <Button type="submit" disabled={processing}>
                {processing ? 'Skapar…' : 'Skapa lag'}
              </Button>
              <Link href="/teams">
                <Button type="button" variant="secondary">Avbryt</Button>
              </Link>
            </div>
          </form>
        </div>
      </div>
    </AuthenticatedLayout>
  )
}
